import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@emotion/react'
import { TabContext, TabPanel } from '@mui/lab';
import { Box, Grid, useMediaQuery, } from '@mui/material'
import { makeStyles } from "@mui/styles"
import NeedHelpButton from 'ui-components/NeedHelpButton'
import Cookies from 'js-cookie'
import BreadcrumbHeader from 'layout/BreadcrumbsHeader'
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper';
import CustomTabs from 'ui-components/CustomTabs';
import Versions from './Versions';
import { useToast } from 'context/ToastContext';
import Users from 'views/settings/Users';
import { useSelector } from 'react-redux';
import { hasPermission } from 'utils/index';
import PromoCodes from './PromoCodes';
import PlansAndPricing from './PlansAndPricing';
import ProfileScore from './ProfileScore';
import UtmCampaigns from './UtmCampaigns';

// import RoundInvestorsNew from './RoundInvestorsNew'

const useStyles = makeStyles((theme) => ({
    scrollTabs: {
        '& > .Mui-disabled.MuiTabs-scrollButtons': {
            display: 'none',
            transition: 'all 1s ease'
        }
    }
}));

const ViewSettingsInformation = ({ tabValue }) => {
    // const { id: round_id } = useParams();
    const round_id = Cookies.get("round_id")
    const theme = useTheme()
    const userAccess = useSelector((state) => state?.permissions);
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
    const [page, setPage] = React.useState(1);
    const parsedCookieForQueryParams = Cookies.get("admin_settings_query") ? JSON.parse(Cookies.get("admin_settings_query")) : {}
    const [queryParams, setQueryParams] = React.useState(parsedCookieForQueryParams);
    const [search, setSearch] = React.useState(Cookies.get("search_admin_settings") || "");
    const [reset, setReset] = React.useState(false);
    const [searchStatus, setSearchStatus] = React.useState(false);
    const refetchListing = () => {

    }
    const classes = useStyles();
    const Actions = () => {
        return (
            <>
                <NeedHelpButton />
            </>
        );
    };

    // let tabValue = new URLSearchParams(window.location.search).get("page");
    // console.log("tabl",tabValue)
    const [value, setValue] = React.useState(tabValue || "release_notes");
    const handleChange = (event, newValue) => {
        setValue(newValue);
        navigate(`/admin_settings/${newValue}`)
    };
    const settingsTabs = [
        {
            label: "Release Notes",
            value: "release_notes",
            permission: hasPermission("super_admin", "backrr_admin_settings_release_notes", userAccess?.userPermissions)
        },
        {
            label: "Admin Users",
            value: "admin_users",
            permission: hasPermission("super_admin", "backrr_admin_settings_admin_users", userAccess?.userPermissions)
        },
        {
            label: "Offer Codes",
            value: "offer_codes",
            // permission: true
            permission: hasPermission("super_admin", "backrr_admin_settings_promo_codes", userAccess?.userPermissions)
        },
        {
            label: "Startup Pricing Page",
            value: "plans_pricing",
            permission: hasPermission("super_admin", "backrr_admin_settings_plans", userAccess?.userPermissions)
        },
        {
            label: "Profile Score",
            value: "profile_score",
            permission: hasPermission("super_admin", "backrr_admin_settings_profile_score", userAccess?.userPermissions)
        },
        {
            label: "UTM Campaigns",
            value: "utm_campaigns",
            permission: hasPermission("super_admin", "backrr_admin_settings_utm_campaigns", userAccess?.userPermissions)
        },
    ]
    return (
        <ThemeBGWrapper bgColor={theme.palette.customColors.yellow_bg}>
            <BreadcrumbHeader
                title="Admin Settings"
                sx={{ paddingBottom: 0 }}
            />

            <>
                <Grid xs={12} container bgColor={theme.palette.customColors.yellow_bg} height={"100%"}>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box px={isSmallScreen ? "1rem" : "2rem"} bgColor={theme.palette.customColors.yellow_bg}>
                                <CustomTabs data={settingsTabs?.filter(item => item?.permission === true)} value={value} isSmallScreen={isSmallScreen} className={classes} handleChange={handleChange} key={"Tabs Tabs"} sx={{ paddingTop: '1rem' }} bgColor={theme.palette.customColors.yellow_bg} />
                            </Box>
                            {hasPermission("super_admin", "backrr_admin_settings_release_notes", userAccess?.userPermissions) && <TabPanel value="release_notes" sx={{ paddingInline: 0, height: '100%' }}>
                                <Versions
                                    refetchListing={refetchListing}
                                    searchStatus={searchStatus}
                                    setSearchStatus={setSearchStatus}
                                    search={search}
                                    reset={reset}
                                    setSearch={setSearch}
                                    setReset={setReset}
                                    queryParams={queryParams}
                                    setQueryParams={setQueryParams}
                                />
                            </TabPanel>}
                            {hasPermission("super_admin", "backrr_admin_settings_admin_users", userAccess?.userPermissions) && <TabPanel value="admin_users" sx={{ paddingInline: 0, height: '100%' }}>
                                <Users
                                    refetchListing={refetchListing}
                                    searchStatus={searchStatus}
                                    setSearchStatus={setSearchStatus}
                                    search={search}
                                    reset={reset}
                                    setSearch={setSearch}
                                    setReset={setReset}
                                    queryParams={queryParams}
                                    setQueryParams={setQueryParams}
                                />
                            </TabPanel>}
                            {/* {<TabPanel value="promo_codes" sx={{ paddingInline: 0, height: '100%' }}> */}
                            {hasPermission("super_admin", "backrr_admin_settings_promo_codes", userAccess?.userPermissions) && <TabPanel value="offer_codes" sx={{ paddingInline: 0, height: '100%' }}>
                                <PromoCodes
                                    refetchListing={refetchListing}
                                    searchStatus={searchStatus}
                                    setSearchStatus={setSearchStatus}
                                    search={search}
                                    reset={reset}
                                    setSearch={setSearch}
                                    setReset={setReset}
                                    queryParams={queryParams}
                                    setQueryParams={setQueryParams}
                                />
                            </TabPanel>}
                            {hasPermission("super_admin", "backrr_admin_settings_plans", userAccess?.userPermissions) && <TabPanel value="plans_pricing" sx={{ paddingInline: 0, height: '100%' }}>
                                <PlansAndPricing />
                            </TabPanel>}
                            {hasPermission("super_admin", "backrr_admin_settings_profile_score", userAccess?.userPermissions) && <TabPanel value="profile_score" sx={{ paddingInline: 0, height: '100%' }}>
                                <ProfileScore />
                            </TabPanel>}
                            {hasPermission("super_admin", "backrr_admin_settings_utm_campaigns", userAccess?.userPermissions) && <TabPanel value="utm_campaigns" sx={{ paddingInline: 0, height: '100%' }}>
                                <UtmCampaigns />
                            </TabPanel>}
                        </TabContext>
                    </Box>
                </Grid>
            </>
            {/* } */}
        </ThemeBGWrapper>
    )
}

export default ViewSettingsInformation